import React from "react";
import type { IconProps } from "./types";

export const ExpandIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function ExpandIcon(
    {
      size = 24,
      width,
      height,
      className = "",
      fill = "currentColor",
      ...props
    },
    ref
  ) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M21 11V3H13V5H17.59L12 10.59L6.41 5H11V3H3V11H5V6.41L10.59 12L5 17.59V13H3V21H11V19H6.41L12 13.41L17.59 19H13V21H21V13H19V17.59L13.41 12L19 6.41V11H21Z"
          fill={fill}
        />
      </svg>
    );
  }
);
